export const parseProfile = (user, profile) => ({
  displayName: profile?.name ?? user.displayName,
  firstName: profile?.given_name,
  lastName: profile?.family_name,
});
